// Delay until auto-opening modals (ex: /app/login and /app/promo) appear
export const MODAL_OPEN_DELAY = 500;
